export default "__VITE_ASSET__2TqbweXL__"